import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-my-account-stats',
  templateUrl: './my-account-stats.component.html',
  styleUrls: ['./my-account-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class MyAccountStatsComponent {
  // constructor() {}
}
